import React, { useEffect, useState } from "react"
import * as api from '../../../../../Auth/auth'
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';

export default function BoneSingleVariantStack() {

   const [data, setData] = useState([])
   
   //Callback function to fetch & store data
   //hook to make the fetchInfo function run every time the page loads
        useEffect(() => {

            async function axios_get() {
                const response =  await api.Bone_Variants_ListFetch();
                const bhnValues = response
                regenerateData(bhnValues)
                
                }

            axios_get()
            
            }, []);
        
            function regenerateData(bhnValues) {
            const bhnData = [];
            let label = 0
            for (let i in bhnValues) {
                const bhnGene = bhnValues[i].SYMBOL
                const clinvar = bhnValues[i].CLIN_SIG
                label = label + 1
                
                bhnData.push({
                label,
                bhnGene,
                clinvar
                });
            }
            //console.log(bhnData)
            setData(bhnData)
            }
  
            const clinCheck = 'pathogenic'
           

return (

<>
{data.length === 0 ? <CheckIcon sx={{ color: "common.white"}}/> :
    
    data.map((dataObj, index) => {
      return (
        <Button variant="contained" size="small" sx={{ 
                                                bgcolor: 'grey.700', ...(dataObj.clinvar === clinCheck && {bgcolor: 'traffic.red'}), 
                                                color: 'common.white', m:1, borderRadius: '12px'}}>
          <div key={index}> {dataObj.bhnGene} </div>
          </Button>
      );

    }) 
    }

        

</>
 ) 
}
